/*
  Product Navigation — Önceki / Rastgele / Sonraki
  ------------------------------------------------
  Ayarlar (koleksiyon eşlemesi, API sürümü, token):
      snippets/product-navigation.liquid  ->  window.__productNavConfig

  Veri kaynağı:
      1) Storefront GraphQL  — sadece handle + stok durumu döner, çok hafif
      2) /collections/<handle>/products.json — yedek. Storefront API sürümü
         kapandığında veya token geçersiz kaldığında devreye girer.
*/
(function () {
  var config = window.__productNavConfig;
  if (!config) return;

  var COLLECTION_HANDLE = config.collectionMap[config.category];
  var MAX_PAGES = 20; // 250 x 20 = 5000 ürün. Sonsuz döngüye karşı emniyet.

  var QUERY = [
    'query navProducts($handle: String!, $cursor: String) {',
    '  collection(handle: $handle) {',
    '    products(first: 250, after: $cursor) {',
    '      pageInfo { hasNextPage endCursor }',
    '      nodes { handle availableForSale }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function productUrl(handle) {
    var root = config.rootUrl || '/';
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root + '/products/' + handle;
  }

  async function fetchViaStorefront(handle) {
    var items = [];
    var cursor = null;
    var hasNext = true;
    var pages = 0;

    while (hasNext && pages < MAX_PAGES) {
      var res = await fetch('/api/' + config.apiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken
        },
        body: JSON.stringify({ query: QUERY, variables: { handle: handle, cursor: cursor } })
      });
      if (!res.ok) throw new Error('Storefront API HTTP ' + res.status);

      var body = await res.json();
      if (body.errors && body.errors.length) throw new Error(body.errors[0].message);

      var page = body.data && body.data.collection && body.data.collection.products;
      if (!page) throw new Error('Koleksiyon bulunamadı: ' + handle);

      page.nodes.forEach(function (node) {
        items.push({ handle: node.handle, available: node.availableForSale });
      });

      hasNext = page.pageInfo.hasNextPage;
      cursor = page.pageInfo.endCursor;
      pages++;
    }

    return items;
  }

  async function fetchViaProductsJson(handle) {
    var items = [];
    var page = 1;

    while (page <= MAX_PAGES) {
      var res = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page);
      if (!res.ok) throw new Error('products.json HTTP ' + res.status);

      var products = (await res.json()).products || [];
      if (products.length === 0) break;

      products.forEach(function (product) {
        items.push({
          handle: product.handle,
          available: product.variants.some(function (variant) { return variant.available; })
        });
      });

      if (products.length < 250) break;
      page++;
    }

    return items;
  }

  var productNav = {
    handles: [],
    currentIndex: -1,
    loaded: false,

    async init() {
      if (!COLLECTION_HANDLE) {
        console.warn('[product-nav] "' + config.category + '" için collectionMap içinde karşılık yok.');
        return;
      }

      var items;
      try {
        items = await fetchViaStorefront(COLLECTION_HANDLE);
      } catch (error) {
        console.warn('[product-nav] Storefront API başarısız, yedeğe geçiliyor:', error.message);
        try {
          items = await fetchViaProductsJson(COLLECTION_HANDLE);
        } catch (fallbackError) {
          console.warn('[product-nav] Ürün listesi alınamadı:', fallbackError.message);
          return;
        }
      }

      // Stokta olmayanları atla. Ancak görüntülenen ürünün kendisi de stok dışıysa
      // filtrelenmiş listede yer almaz ve currentIndex -1 kalır; o durumda ileri/geri
      // hiç çalışmaz. Bu yüzden böyle bir durumda tam listeye dönüyoruz.
      var inStock = items.filter(function (item) { return item.available; })
                         .map(function (item) { return item.handle; });

      if (inStock.indexOf(config.currentHandle) !== -1) {
        this.handles = inStock;
      } else {
        this.handles = items.map(function (item) { return item.handle; });
      }

      this.currentIndex = this.handles.indexOf(config.currentHandle);
      this.loaded = true;
      this.updateButtons();
    },

    updateButtons() {
      var prev = document.getElementById('btn-prev');
      var next = document.getElementById('btn-next');
      if (!prev || !next) return;

      prev.classList.remove('product-nav-btn--disabled');
      next.classList.remove('product-nav-btn--disabled');

      if (this.handles.length === 0) return;

      if (this.currentIndex <= 0) prev.classList.add('product-nav-btn--disabled');
      if (this.currentIndex >= this.handles.length - 1) next.classList.add('product-nav-btn--disabled');
    },

    go(direction) {
      if (!this.loaded || this.handles.length === 0) return;

      var target;

      if (direction === 'prev') {
        if (this.currentIndex <= 0) return;
        target = this.handles[this.currentIndex - 1];
      } else if (direction === 'next') {
        if (this.currentIndex >= this.handles.length - 1) return;
        target = this.handles[this.currentIndex + 1];
      } else if (direction === 'random') {
        var i;
        do { i = Math.floor(Math.random() * this.handles.length); }
        while (i === this.currentIndex && this.handles.length > 1);
        target = this.handles[i];
      }

      if (target) window.location.href = productUrl(target);
    }
  };

  window.productNav = productNav;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { productNav.init(); });
  } else {
    productNav.init();
  }
})();
